
import Vue from "vue";
import { ExtraFieldNamesConfig, ExtraFieldType } from "@/models/dossier-configs/extra-field-names-config";
import { ExtraFieldsType, getExtraFieldCount } from "@/utils/models/extra-fields";
import AppExtraFieldRow from "./ExtraFieldRow.vue";

export default Vue.extend({
	data(){
		return {
			pendingIndexes: [] as number[],
			visibleIndexes: [] as number[],
			focusIndex: 0,
			slotMenuOpen: false
		};
	},
	props: {
		settings: {
			type: Object as () => ExtraFieldNamesConfig,
			required: true
		},
		type: {
			type: String as () => ExtraFieldType,
			required: true
		},
		extraFieldsType: {
			type: String as () => ExtraFieldsType,
			required: true
		}
	},
	computed: {
		maxCount():number {
			return getExtraFieldCount();
		},
		order():number[] {
			return this.settings.getOrder(this.type);
		},
		usedIndexes():number[] {
			return this.settings.getUsedIndexes(this.type);
		},
		freeIndexes():number[] {
			return this.settings.getFreeIndexes(this.type).filter(i=>this.pendingIndexes.indexOf(i) == -1);
		},
		computedVisible():number[] {
			return this.order.filter(i=>this.settings.isIndexUsed(this.type, i) || this.pendingIndexes.indexOf(i) != -1);
		},
		keyPrefix():string {
			return ({Text: "T", Num: "N", Bool: "B", Time: "D"} as any)[this.type];
		}
	},
	watch: {
		computedVisible: {
			immediate: true,
			handler(){
				this.visibleIndexes = [...this.computedVisible];
			}
		},
		usedIndexes(){
			this.pendingIndexes = this.pendingIndexes.filter(i=>!this.settings.isIndexUsed(this.type, i));
		}
	},
	methods: {
		addFirstFree(){
			let index = this.freeIndexes[0];
			if (!index) return;
			this.addIndex(index);
		},
		addIndex(index:number){
			if (this.pendingIndexes.indexOf(index) == -1) {
				this.pendingIndexes.push(index);
			}
			this.focusIndex = index;
		},
		clearIndex(index:number){
			this.settings.clearField(this.type, index);
			this.pendingIndexes = this.pendingIndexes.filter(i=>i != index);
		},
		onDrop(){
			let rest = this.order.filter(i=>this.visibleIndexes.indexOf(i) == -1);
			this.settings.setOrder(this.type, [...this.visibleIndexes, ...rest]);
		}
	},
	components: {
		AppExtraFieldRow
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
